/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ordernumber1Inputs */

const de__field_ordernumber1 = /** @type {(inputs: _Field_Ordernumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellnummer`)
};

/**

* @param {_Field_Ordernumber1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ordernumber1 = /** @type {((inputs?: _Field_Ordernumber1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ordernumber1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_ordernumber1(inputs)
});
export { _field_ordernumber1 as "_field_orderNumber" }